<template>
  <div>
    <portal to="top-bar-right">
      <div class="flex justify-right">
        <YButton
          class="btn btn-blue "
          @click="createNewCampaign"
          :is-loading="isCreating"
        >
          New Campaign
        </YButton>
      </div>
    </portal>
    <CampaignsTableWrapper></CampaignsTableWrapper>
  </div>
</template>

<script>
import CampaignsTableWrapper from '@/components/legacy/Campaigns/AdminCampaignsTableWrapper'

export default {
  components: {
    CampaignsTableWrapper
  },
  data() {
    return {
      isCreating: false
    }
  },

  mounted() {},

  updated() {},

  methods: {
    createNewCampaign() {
      this.$router.push({ name: 'Create Campaign' })
    }
  }
}
</script>
<style></style>
